const height = 'msPointerEnabled' in navigator || 'msDoNotTrack' in navigator ? '99%' : '100%';

export default {
    functional: true,
    render(h, context) {
        const { src } = context.props;
        const { staticClass, staticStyle } = context.data;
        return (
            <div class={staticClass} style={staticStyle}>
                <iframe height={height} src={src} id="iframe-dual" width="100%" frameborder="0" />
            </div>
        );
    },
};
